import Vue from 'vue'
import Router from 'vue-router'

const AuthService = require('@/services/auth/AuthService')
const UserService = require('@/services/users/UserService')

const state = {
    identity: null,
    token: null
}

const getters = {
    authGetIdentity: state => state.identity,
    authHasIdentity: state => (state.identity !== null)
}

const mutations = {
    authSetIdentity(state, identity) {
        state.identity = identity
    },

    authSetToken(state, token) {
        state.token = token
    }
}

const actions = {
    /**
     * Set access token
     *
     * @param commit
     * @param dispatch
     * @param payload
     */
    authSetAccessToken({commit, dispatch}, payload) {
        const token = payload.token;

        const vm = new Vue()

        // Set header
        vm.$http.defaults.headers.common.Authorization = 'Bearer ' + token;

        commit('authSetToken', token);

        dispatch('authLoadIdentity', payload)
    },

    /**
     * Load identity
     *
     * @param commit
     * @param dispatch
     * @param payload
     */
    authLoadIdentity({commit, dispatch}, payload) {
        const vm = new Vue()

        UserService.identity({}, function (response) {
            if (response.status !== 200) {
                return false
            }

            const identity = response.data

            commit('authSetIdentity', response.data)

            if (payload.cb !== undefined) {
                payload.cb()
            }
        }, () => {
            dispatch('authSignOut')
        })
    },

    /**
     * Sign out
     *
     * @param context
     * @param cb
     */
    authSignOut(context, cb) {
        const vm = new Vue()

        vm.$localStorage.remove('token')

        Vue.router.push({
            name: 'login'
        })
    },

    /**
     * Refresh token
     *
     * @param dispatch
     * @param payload
     */
    authRefreshToken({dispatch}, payload) {
        const vm = new Vue()

        // vm.$http.defaults.headers.common.Authorization = null

        // Forget token
        vm.$http.post('login/refresh').then((response) => {
            const body = response.data
            const token = body.access_token

            // Set header
            vm.$http.defaults.headers.common.Authorization = 'Bearer ' + token

            vm.$localStorage.set('token', token)

            if (payload && payload.cb) {
                payload.cb()
            }
        }).catch(error => {
            // dispatch('authSignOut')
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js